<template>
    <div class="withdraw">
        <nav-bar></nav-bar>
        <div :class="isMobile ? 'm-content' :'content'">
            <div class="tabs" v-if="isMobile">
                <div :class="active == 1 ? 'active' : ''" @click="active = 1">{{ $t('提款') }}</div>
                <div :class="active == 2 ? 'active' : ''" @click="active = 2">{{ $t('提款记录') }}</div>
            </div>
            <div class="box" v-if="!isMobile">
                <div class="box-left">
                    <div class="box-card">
                        <div class="card-top">
                            <div class="left">
                                <p>{{ $t('账户余额') }}</p>
                                <span>USD {{ infos.balance }}</span>
                            </div>
                        </div>
                        <P>{{ $t('您将在5-10分钟内收到提款') }}</P>
                    </div>
                    <div class="line"></div>
                    <p class="look">{{ $t('请注意，提款请求是即时的，但资金可能需要5-30分钟才能到达您的提款地址。提款方式提款将被转发到提供的地址。') }}</p>
                    <div class="line"></div>
                    <p class="way">{{ $t('提款方式') }}</p>
                    <p class="look">{{ $t('提款将被转发到提供的地址。') }}</p>
                    <!-- 钱包地址 -->
                     <div class="wallet">
                        <p class="look">{{ $t('钱包地址') }}</p>
                        <!-- <div class="address">{{ address }}</div> -->
                        <el-input :placeholder="$t('钱包地址')" v-model="address"></el-input>
                     </div>
                     <!-- 提现金额 -->
                      <div class="money">
                        <p class="look">{{ $t('请输入金额') }}</p>
                        <el-input v-model="money">
                            <template v-slot:suffix>
                                <span style="cursor: pointer;" @click="setAll">{{ $t('全部') }}</span>
                            </template>
                        </el-input>
                      </div>
                      <!-- 提现密码 -->
                      <div class="password">
                        <p class="look">{{ $t('提现密码') }}</p>
                        <el-input v-model="password" show-password></el-input>
                      </div>
                      <!-- 提现 -->
                       <el-button round style="background-color: #000;color: #fff;padding: 15px 0;width: 100%;" @click="submit">{{ $t('提现') }}</el-button>
                </div>
                <div class="box-right">
                    <span style="margin-bottom: 20px;font-weight: 600;font-size: 18px;">{{ $t('提现历史') }}</span>
                    <div class="list-item" v-for="(item,index) in list" :key="index">
                        <div class="list-top">
                            <span>{{ item.id }}</span>
                            <p>{{ $t('订单号') }}</p>
                        </div>
                        <div class="list-top">
                            <span style="font-size: 12px;color: #999;">{{ item.addtime }}</span>
                            <span style="color: red;padding-bottom: 10px;font-size: 12px;">USD {{ item.num }}</span>
                        </div>
                        <div class="list-top" v-if="!isMobile">
                            <span style="font-size: 14px;">{{ $t('状态') }}</span>
                            <div class="success">{{ item.status == 1 ? $t('待处理') : item.status == 2 ? $t('成功') : $t('失败') +'：'+item.payout_err_msg }}</div>
                        </div>
                    </div>
                    
                    <div class="empty" v-if="list.length == 0">
                        <img src="../../assets/img/empty.png" />
                    </div>
                </div>
            </div>
            <div class="box" v-else>
                <div class="box-left" v-if="active == 1">
                    <div class="box-card">
                        <div class="card-top">
                            <div class="left">
                                <p>{{ $t('账户余额') }}</p>
                                <span>USD {{ infos.balance }}</span>
                            </div>
                        </div>
                        <P>{{ $t('您将在5-10分钟内收到提款') }}</P>
                    </div>
                    <div class="line"></div>
                    <p class="look">{{ $t('请注意，提款请求是即时的，但资金可能需要5-30分钟才能到达您的提款地址。提款方式提款将被转发到提供的地址。') }}</p>
                    <div class="line"></div>
                    <p class="way">{{ $t('提款方式') }}</p>
                    <p class="look">{{ $t('提款将被转发到提供的地址。') }}</p>
                    <!-- 钱包地址 -->
                     <div class="wallet">
                        <p class="look">{{ $t('钱包地址') }}</p>
                        <!-- <div class="address">{{ address }}</div> -->
                         <el-input :placeholder="$t('钱包地址')" v-model="address"></el-input>
                     </div>
                     <!-- 提现金额 -->
                      <div class="money">
                        <p class="look">{{ $t('请输入金额') }}</p>
                        <el-input v-model="money" type="number">
                            <template v-slot:suffix>
                                <span style="cursor: pointer;" @click="setAll">{{ $t('全部') }}</span>
                            </template>
                        </el-input>
                      </div>
                      <!-- 提现密码 -->
                      <div class="password">
                        <p class="look">{{ $t('提现密码') }}</p>
                        <el-input v-model="password" show-password></el-input>
                      </div>
                      <!-- 提现 -->
                       <el-button round style="background-color: #000;color: #fff;padding: 15px 0;width: 100%;" @click="submit">{{ $t('提现') }}</el-button>
                </div>
                <div class="box-right" v-if="active == 2">
                    <div class="list-item" v-for="(item,index) in list" :key="index">
                        <div class="list-top">
                            <span>{{ item.id }}</span>
                            <p>{{ $t('订单号') }}</p>
                        </div>
                        <div class="list-top">
                            <span style="font-size: 12px;color: #999;">{{ item.addtime }}</span>
                            <span style="color: red;padding-bottom: 10px;font-size: 12px;">USD {{ item.num }}</span>
                        </div>
                        
                        <div class="list-top" v-if="!isMobile">
                            <span style="font-size: 12px;color: #999;">{{ $t('状态') }}</span>
                            <div class="success">{{ item.status == 1 ? $t('待处理') : item.status == 2 ? $t('成功') : $t('失败') +'：'+item.payout_err_msg }}</div>
                        </div>
                        <div class="list-top" v-else>
                            <span style="font-size: 12px;color: #999;">{{ $t('状态') }}</span>
                            <div style="text-align: right; font-size: 12px;">{{ item.status == 1 ? $t('待处理') : item.status == 2 ? $t('成功') : $t('失败') +'：'+item.payout_err_msg }}</div>
                        </div>
                        
                    </div>
                    
                    <div class="empty" v-if="list.length == 0">
                        <img src="../../assets/img/empty.png" />
                    </div>
                </div>
            </div>
        </div>
        <footers v-if="!isMobile"></footers>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { address, info, withdraw, withdrawRecord } from '../../api/index'
import formDate from '../../utils/formDate'
export default {
    data() {
        return {
            money: '',
            password: '',
            active: 1,
            address: '',
            infos: {},
            list: [],
            isSub: false
        }
    },
    computed: {
        ...mapGetters("device", ["isMobile"]),
    },
    created() {
        this.getWallet()
        this.getAddress()
        this.getList()
    },
    methods: {
        getWallet() {
            info().then((res) => {
                if (res.code == 0) {
                    this.infos = res.data.info;
                }
            });
        },
        getList() {
            withdrawRecord({page:1,size:30}).then(res=> {
                if (res.code == 0) {
                    var result = res.data.list
                    result.map((el,i)=> {
                        el.addtime = formDate.getYMDHMS(el.addtime * 1000)
                    })
                    this.list = result
                }
            })
        },
        getAddress() {
            address().then(res=> {
                if (res.code == 0) {
                    if (!res.data.info) {
                        this.$message({
                            message: this.$t('尚未绑定提款地址，请先绑定提款地址！'),
                            type: 'warning'
                        })
                        setTimeout(() => {
                            this.$router.push('/wallet')
                        }, 3000);
                    } else {
                        this.address = res.data.info.usdt_diz
                    }
                }
            })
        },
        // 添加全部
        setAll() {
            this.money = this.infos.balance
        },
        submit() {
            if (this.isSub) {
                return
            }
            this.isSub = true
            if (!this.money) {
                return this.$message({
                            message: this.$t('请输入金额'),
                            type: 'warning'
                        });
            }
            if (!this.password) {
                return this.$message({
                            message: this.$t('请输入密码'),
                            type: 'warning'
                        });
            }
            withdraw({num: this.money,type:'bank',paypassword: this.password, address: this.address}).then(res=> {
                if (res.code == 0) {
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                    this.money = ''
                    this.password = ''
                    this.getList()
                }

                setTimeout(() => {
                    this.isSub = false
                }, 2000);
            }).catch(()=> {
                this.isSub = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.withdraw {
    background-color: #fff;
    .content {
        background: #f8f8f8;
        background-image: linear-gradient(-225deg, #2cd8d5, #c5c1ff 56%, #ffbac3);
        background-position: 0;
        background-size: cover;
        display: flex;
        justify-content: center;
        min-height: 100vh;
        width: 100%;

        .box {
            width: 60%;
            margin: 20px auto;
            background-color: #fff;
            min-height: 100vh;
            border-radius: 9px;
            display: flex;
            justify-content: space-between;
            padding-bottom: 40px;

            .box-left {
                flex: 1;
                padding: 30px;

                .box-card {
                    padding: 10px 20px;
                    background-color: #1e4de7;
                    font-size: 14px;
                    color: #fff;
                    border-radius: 12px;
                    margin-top: 20px;

                    .card-top {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        p {
                            font-size: 14px;
                            color: #fff;
                            margin: 5px 0;
                        }

                        span {
                            font-size: 21px;
                            color: #fff;
                        }
                    }
                }

                .line {
                    width: 100%;
                    height: 1px;
                    background-color: #ebedf0;
                    margin: 30px 0;
                }

                .look {
                    font-size: 14px;
                    color: #333;
                }

                .way {
                    font-size: 16px;
                    font-weight: 600;
                    margin: 10px 0;
                }

                .wallet {
                    margin: 15px;
                    border-bottom: 1px solid #ebedf0;
                    font-size: 14px;

                    .address {
                        padding: 10px 0;
                    }
                }

                .money, .password {
                    margin: 15px;
                    border-bottom: 1px solid #ebedf0;
                    font-size: 14px;

                    :deep(.el-input__inner) {
                        border: none;
                        padding: 0;
                    }

                    :deep(.el-input__suffix) {
                        display: flex;
                        align-items: center;
                        color: #000;
                    }
                }

            }

            .box-right {
                flex: 1;
                padding: 30px;

                .list-item {
                    border-radius: 8px;
                    box-shadow: 0 2px 8px 0 rgba(99, 99, 99, .2);
                    box-sizing: border-box;
                    margin-top: 10px;
                    margin-bottom: 20px;
                    padding: 3%;
                    width: 100%;

                    .list-top {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        color: #000;
                    }

                    .success {
                        text-align: center;
                        color: #fff;
                        background-color: #1e4de7;
                        float: right;
                        padding: 5px 20px;
                        font-size: 14px;
                    }
                    &::after {
                        content: "";
                        display: table;
                        clear: both;
                    }
                }
            }
        }
    }

    .m-content {

        .empty {
            width: 100%;
            img {
                width: 100%;
            }
        }

        .tabs {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 30px 0;

            div {
                width: 50%;
                text-align: center;
                pad: 14px 0;
                color: #999;
            }

            .active {
                width: 50%;
                text-align: center;
                pad: 14px 0;
                color: #1e4de7;
            }
        }
        .box {
            background-color: #fff;
            min-height: 100vh;
            border-radius: 9px;
            display: flex;
            justify-content: space-between;

            .box-left {
                flex: 1;
                padding: 0 30px;

                .box-card {
                    padding: 10px 20px;
                    background-color: #1e4de7;
                    font-size: 14px;
                    color: #fff;
                    border-radius: 12px;

                    .card-top {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        p {
                            font-size: 14px;
                            color: #fff;
                            margin: 5px 0;
                        }

                        span {
                            font-size: 21px;
                            color: #fff;
                        }
                    }
                }

                .line {
                    width: 100%;
                    height: 1px;
                    background-color: #ebedf0;
                    margin: 30px 0;
                }

                .look {
                    font-size: 14px;
                    color: #333;
                }

                .way {
                    font-size: 16px;
                    font-weight: 600;
                    margin: 10px 0;
                }

                .wallet {
                    margin: 15px;
                    border-bottom: 1px solid #ebedf0;
                    font-size: 14px;

                    .address {
                        padding: 10px 0;
                    }
                }

                .money, .password {
                    margin: 15px;
                    border-bottom: 1px solid #ebedf0;
                    font-size: 14px;

                    :deep(.el-input__inner) {
                        border: none;
                        padding: 0;
                    }

                    :deep(.el-input__suffix) {
                        display: flex;
                        align-items: center;
                        color: #000;
                    }
                }

            }

            .box-right {
                flex: 1;
                padding: 30px;

                .list-item {
                    border-radius: 8px;
                    box-shadow: 0 2px 8px 0 rgba(99, 99, 99, .2);
                    box-sizing: border-box;
                    margin-bottom: 20px;
                    min-height: 100px;
                    padding: 3%;
                    width: 100%;

                    .list-top {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        color: #000;
                    }

                    .success {
                        text-align: center;
                        color: #fff;
                        background-color: #1e4de7;
                        float: right;
                        padding: 5px 20px;
                        font-size: 14px;
                    }
                    &::after {
                        content: "";
                        display: table;
                        clear: both;
                    }
                }
            }
        }
    }
}
</style>